import { gql } from "graphql-request"

const cosmoshub = {
    name: 'cosmoshub',
    title: 'Cosmos Hub Network',
    currency: 'ATOM',
    check: true,
    regexp:
    '([\\W]|^)((cosmos1|terra1|tcro1|tcrocncl1)[a-zA-HJ-NP-Z0-9]{38,70})([\\W]|$)',
    noregxp: [
        '([\\W]|^)(bnb[0-9a-z]{2})([\\W]|$)',
        '([\\W]|^)(bnb[0-9a-z]{2)([\\W]|$)',
        '([\\W]|^)(T[\\w]{2})([\\W]|$)',
        '([\\W]|^)(T[\\w]{2})([\\W]|$)',
    ],
    query: gql`query ($address: String!) {
        cosmoshub: cosmos(network: cosmoshub) {
            address(address: {is: $address}){
                balance:balance
                balance_usd: balance(in: USD)
            }
            ins: transfers(receiver: {is: $address}) {
                count
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
            currencyIn: transfers(receiver: {is: $address}) {
                count
                currency {
                    symbol
                    address
                    tokenId
                }
            }
            outs: transfers(sender: {is: $address}) {
                count
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
            currencyOut: transfers(sender: {is: $address}) {
                count
                currency {
                    symbol
                    address
                    tokenId
                }
            }
        }
    }`,
    checkAddress: 'cosmos1m7pzv79dsp8pcc2dt38re3tav08zjmjhzd2kyy',
}
export { cosmoshub }
